var map = {
	"./Group 193.svg": "04ed",
	"./Icon_ionic-ios-close.svg": "3454",
	"./account.svg": "2407",
	"./alarm.svg": "2d76",
	"./arrow.svg": "b94f",
	"./cashBag.svg": "d11b",
	"./close-circle.svg": "f5cd",
	"./close.svg": "bf37",
	"./copy-regular.svg": "baa4",
	"./cupom.svg": "1236",
	"./ear_32x32_white.svg": "ad99",
	"./exit.svg": "019c",
	"./filter-focused.svg": "ef76",
	"./filter.svg": "5ee4",
	"./flag-br.svg": "41bb",
	"./flag-pt.svg": "54ae",
	"./fullscreen.svg": "8625",
	"./highres.svg": "b7e0",
	"./icon-call.svg": "0c41",
	"./icon-hangout.svg": "8fa7",
	"./icon-mail.svg": "9409",
	"./icon-messenger.svg": "37f2",
	"./icon-money.svg": "0f17",
	"./icon-seta.svg": "0812",
	"./icon_ondivan_white.svg": "9cf8",
	"./icone-highres.svg": "dfbb",
	"./icone-money.svg": "d6f9",
	"./info-red.svg": "0f64",
	"./logo-skype.svg": "83ab",
	"./logo-whatsapp.svg": "a4b3",
	"./logo.svg": "9b19",
	"./mao.svg": "07a5",
	"./md-star.svg": "ebc6",
	"./money.svg": "f7cb",
	"./ondivan_marca_red.svg": "30c3",
	"./ondivan_marca_white.svg": "62f0",
	"./ondivan_marca_white_slogan.svg": "7f31",
	"./parceiros_icon.svg": "4c60",
	"./pause.svg": "ec7e",
	"./phone.svg": "001e",
	"./play.svg": "5830",
	"./stripe.svg": "0a37",
	"./wave_home.svg": "44c5",
	"./wave_home_red.svg": "9e1d",
	"./whatsapp.svg": "3357"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";